import { render } from "./Loading.vue?vue&type=template&id=5c48c652&scoped=true"
import script from "./Loading.vue?vue&type=script&lang=js"
export * from "./Loading.vue?vue&type=script&lang=js"

import "./Loading.vue?vue&type=style&index=0&id=5c48c652&lang=css"
import "./Loading.vue?vue&type=style&index=1&id=5c48c652&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c48c652"]])

export default __exports__